<template>
	<div class="ReLeadCallCat mt-3">
		<div class="row">
			<div class="col-lg-6 col-md-12 ">
				<label>Выбрать/Позвонить ответственному сотруднику</label>	
				<div class="">
				<!-- <div class="d-flex flex-sm-wrap flex-md-nowrap"> -->
					<div calss="callSearchDrop w-100 mr-2" style="display: flex; flex-direction: row;">
						<div class="form-group w-100" :class="[required===true?'required':'']">
							<ReInputSearchDrop
								:findId="'agent_id'"
								:placeholder="'Найти сотрудника'"
								v-model="bufferValue"
								:objApiMethod="{'obj':'staff' ,'flt':{'fio':''}}"
								:strApiMethodKey="'fio'"
								:required="required"
								@change="onAgentChange"
								class="mr-2 w-100"
							/>
						</div>
						<div class="d-flex" style="width:fit-content;">
							<base-button type="danger" class="no-border my-0" simple icon @click="value.inputText =''; value.selectedVal=''; agent_contacts = {'inputText':'','selectedVal':''}"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
						</div>
					</div>
					<div class="d-flex justify-content-between">
						<div class="d-flex mr-3 align-items-center" v-if="this.agent_contacts.MobilePhone !=''">
							<span v-if="agent_contacts.MobilePhone && agent_contacts.MobilePhone !=''" class="mr-2">Моб.: {{ this.agent_contacts.MobilePhone }}</span>
							<RePhoneCallButton
								v-if="agent_contacts.MobilePhone && agent_contacts.MobilePhone !=''"
								:phone="agent_contacts.MobilePhone"
								:lead_id="$route.params.lead_id"
								
							/>
						</div>
						<div class="d-flex align-items-center" v-if="this.agent_contacts.InternalPhone !=''">
							<span v-if="agent_contacts.InternalPhone && agent_contacts.InternalPhone !=''" class="mr-2">Доб.: {{ this.agent_contacts.InternalPhone }}</span>
							<RePhoneCallButton
								v-if="agent_contacts.InternalPhone && agent_contacts.InternalPhone !=''"
								:phone="agent_contacts.InternalPhone"
								:lead_id="$route.params.lead_id"
								
							/>
						</div>
					</div>
					<!-- <base-button @click="callAgent" type="success" class="btn btn-icon my-0" simple><i class="tim-ic ic-phone pt-1"></i></base-button> -->
					
				</div>	
				<div class="d-flex flex-sm-wrap flex-md-nowrap">
					<span v-if="this.hasNoPhone == true">Контактов не найдено</span>
				</div>
				
				<!-- <div class="d-flex flex-sm-wrap flex-md-nowrap text-danger">МОЖЕТ телефоны СДЕЛАТЬ СРАЗУ ССЫЛКАМИ, КОТОРЫЕ БУДУТ ЗВОНИТЬ?</div> -->
			</div>
			
			<div class="col-lg-6 col-md-12 ">
				<label>Позвонить на вертушку по справочнику</label>	
				<div class="d-flex flex-sm-wrap flex-md-nowrap">
					<el-select
						class="select-primary mr-2"
						size="large"
						:findId="findId"
						:placeholder="placeholder"
						v-model="contact_value"
					>
						<el-option
							v-for="(el_opt, el_index) in masOptions"
							class="select-primary"
							:value="el_opt.phone"
							:label="'доб. ' + el_opt.phone + ': ' + el_opt.description"
							:key="el_index"
						>
						</el-option>
					</el-select>
					<RePhoneCallButton
						:phone="contact_value"
						:lead_id="$route.params.lead_id"
						
					/>
					<!-- <base-button type="success" class="btn btn-icon my-0" simple><i class="tim-ic ic-phone pt-1"></i></base-button> -->
				</div>
			</div>
			
			<template>
				<input type="hidden" class="form-control" v-model="bufferObjects">
			</template>
			<!-- <div v-if="!bIsShown">
				Произошел звонок этому челу или отделу: {{ this.agent_id }} телефон: {{ this.contact_value }}
			</div>	 -->
			
		</div>
	</div>
</template>

<!-- что нужно от компонента: "только вызов API для звонка. скорее всего надо передать "идентификатор лида" и номер на который вызов" -->

<script>
	import { Select, Option, Button } from 'element-ui';
	import ReInputSearchDrop from "src/our_components/ReInputSearchDrop.vue";
	import RePhoneCallButton from "src/our_components/RePhoneCallButton.vue";
	export default {
		name: 'ReLeadCallCat',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
			[Button.name]: Button,
			ReInputSearchDrop,
			RePhoneCallButton,
		},
		props: {
			value: [Object, Number],
			placeholder:{
				type: String,
				default: '',
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			externalParamsValue:{
                type: Object,
                default(){ return {}; },
            },
			isObjects: {
				type: Boolean,
				default(){return false;},
			},
			required:{
				type: Boolean,
				default: false
			},
			// auto_hidden: Boolean,
		},
		data () {
			return {
				ver: 1,
				masOptions:[],
				objCall:{},
				agent_id:'',
				lead_id:'',
				contact_value: '',
				bIsShown: false,
				agent_model: {
					// inputText: this.objService.agent_name,
					// selectedVal: this.objService.agent_id
					inputText: '',
					selectedVal: '',
				},
				agent_model_cache:{
					inputText: '',
					selectedVal: '',
				},
				agent_model_cache_previous:{
					inputText: '',
					selectedVal: '',
				},
				agent_contacts: {
					MobilePhone: '',
					InternalPhone: '',
				},
				hasNoPhone: false,
				bufferValue: {},
				bufferObjects: '',
				
			}
		},
		watch: {
			value(val){
				// нужно, чтобы ловить значение в другом компоненте в форм-принтере
				// this.$emit("input", val);
				// this.onAgentChange();
				// console.log('update value',this.value, val)
				this.bufferValue = this.value;
			},
			externalParamsValue:{
				// магия получения параметров из других компонентов формпринтера
                handler(value){
                    this.prepareData();
					
                },
                deep: true,
            },
			// isObjects:{
            //     handler(value){
            //         value = this.bufferObjects;
			// 		//console.log('externalParamsValue',value);
            //     },
            //     deep: true,
            // },
			isObjects(newval){
				
				this.bufferObjects = newval;
			},
			bufferObjects(newval){
				this.bufferObjects =newval;
				this.$emit('OnIsObjects', this.bufferObjects);
				// this.$emit("change", this.bufferObjects);
				
			},

			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			// 	if (/*this.masObjects.length > 0*/ this.bufferValue !='') {
			// 		this.onAgentChange();
			// 	}
			},

		},
		computed: {

		},
		methods: {
			getPnoneNumbers(){
				// тут будет получение справочника для селекта с телефонами
				this.$GVO.ApiCall('LEAD.GET_phonebook',{flt:{act: 1}} )
					.then((objApi) => {
						// console.log(objApi.data);
						if(objApi.success === true){ 
							//console.log(objApi.data);
							this.masOptions = this.$GVO.unlinkObject(objApi.data);
						}else{
							this.masOptions = [];
						} 
					}).catch(errorObjApi => {this.masOptions = []; console.error(errorObjApi); });

			},
			onAgentChange(evt){
				// this.agent_contacts = [];
				this.agent_model_cache_previous = this.agent_model_cache;
				this.agent_model_cache = evt;
				this.hasNoPhone = false;

				if(this.agent_model_cache.selectedVal !=''){
					this.$GVO.ApiCall('staff.GET',{flt:{code:this.agent_model_cache.selectedVal }})
					.then((objApi) => {
						// console.log('agent_contacts', objApi.data[0]);
						if(objApi.success === true){ 
							this.agent_contacts = {'MobilePhone' : objApi.data[0].MobilePhone, 'InternalPhone' : objApi.data[0].InternalPhone};
							if(objApi.data[0].MobilePhone == '' && objApi.data[0].InternalPhone == '' ){
								this.hasNoPhone = true;
							}
						}else{
							this.agent_contacts = [];
							this.hasNoPhone = false;
						} 
					}).catch(errorObjApi => {this.agent_contacts = {}; console.error(errorObjApi); });
				}
				
			},
			getLeadID(){
				this.lead_id = typeof this.$route.params.lead_id == 'undefined'?'0':this.$route.params.lead_id;
			},
			prepareData(){ 
				if(!this.externalParamsValue) return;
				if(this.externalParamsValue.objects_json && this.externalParamsValue.objects_json!=''){
					try{
                        this.bufferObjects = true;
                    }catch(e){}
				}
				// console.log(this.isObjects);
			}


		},
		mounted(){
			// this.agent_model_cache_previous = {
			// 	inputText: this.objService.agent_name,
			// 	selectedVal: this.objService.agent_id
			// };
			this.bufferValue = this.value;
			this.getLeadID();
			this.getPnoneNumbers();
			this.onAgentChange(this.value);
			this.prepareData();
			this.bufferObjects = this.isObjects;
		},
		created(){

		}
	}
</script>
<style scoped>
.ReLeadCallCat{
	padding: 10px;
	border: 1px dashed #01B0E0;
	border-radius: 6px;
	width: 1056px;
}
.ReLeadCallCat >>> .ReInputSearchDrop {width: 100%;}
.ReLeadCallCat >>> .ReInputSearchDrop > .form-group {width: 100%;}
.ReLeadCallCat >>> .callSearchDrop {display: flex; flex-direction: row;}

@media (max-width: 1300px){
	.ReLeadCallCat{width: 100%;}
}

</style>
